import _ from 'lodash';
import { QueryString } from '~/utils';
import { get, post, patch, put, del } from './agent';

const opportunityPipelines =
  (workspacesUrl) =>
  (id = '') => {
    const url = _([workspacesUrl, 'opportunity-pipelines', id]).compact().join('/');

    return {
      get: (query = {}, config) => get(url.concat(new QueryString(query).toString(true)), config),
      hasDependencies: () => get(url.concat('/has-dependencies')),
      hasActiveStages: () => get(url.concat('/has-active-stages')),
      upsert: (body) => (id ? patch : post)(url, body),
      setActiveStatus: (flag = true) => put(url.concat('/is-active'), { isActive: flag }),
      delete: () => del(url),
    };
  };

export default opportunityPipelines;
